import { StepProps } from '@betterment/js-runtime';
import { SuccessFullScreen } from '@betterment/samba-react';
import { ErrorBoundary } from '@betterment/shared-components';

import { WithLayout } from '../RetailApp/components/WithLayout';
import { locationAssign } from '../Shared/path-helpers';

const PinChangeFlowSuccess: React.FC<React.PropsWithChildren<StepProps>> = ({ flowState }) => {
  const { returnToPath: returnTo } = flowState;

  return (
    <ErrorBoundary>
      <WithLayout parts={{ sidebar: false, footer: false }}>
        <SuccessFullScreen
          message="Your debit card PIN has been changed"
          onCompletion={() => locationAssign(returnTo)}
        />
      </WithLayout>
    </ErrorBoundary>
  );
};

export default PinChangeFlowSuccess;
